const filterObject = (inputObj, keyStr) => Object.keys(inputObj)
    .filter((key) => key.includes(keyStr))
    .reduce((obj, key) => {
        obj[key] = inputObj[key];
        return obj;
    }, {});

/* Takes level averages and stadndard deviations and returns the correct objects based on levelid and yearid */
const getLevelAvgAndStDev = (levelAvgs, levelid, yearid) => {
    // Use MLB standard deviations. If current season not available, get previous season.
    let mlbavgstdev = levelAvgs.find((st) => st.yearid === yearid && st.levelid === 8);
    if (!mlbavgstdev) mlbavgstdev = levelAvgs.find((st) => st.yearid === yearid - 1 && st.levelid === 8);

    // Use season level avg. If current season not available, use previous season. If neither, use  MLB.
    let levelavg = levelAvgs.find((avg) => avg.yearid === yearid && avg.levelid === levelid);
    if (!levelavg) levelavg = levelAvgs.find((avg) => avg.yearid === yearid - 1 && avg.levelid === levelid);
    if (!levelavg) levelavg = mlbavgstdev;

    const mlbStDev = filterObject(mlbavgstdev || {}, '_stdev');
    const levelAvg = filterObject(levelavg || {}, '_avg');

    return { mlbStDev, levelAvg };
};

export {
    getLevelAvgAndStDev,
};
